export default __webpack_public_path__ + "static/media/HowToExt1.2a926a62.webm";